export enum DoctorBookingType {
  WALK_IN = 'WALK_IN',
  IN_PERSON = 'IN_PERSON',
  ONLINE = 'ONLINE',
}
